export default "__VITE_ASSET__CIfhzYDx__"